import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useForm, FormProvider } from "react-hook-form";
// BOOTSTRAP
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
// ICONS
import { SearchIcon, XIcon } from "../../../public/icons/icons";
// STYLE
import s from "./SearchBar.module.scss";
import { removeEmptyKeys } from "@/common/utils/sharedFunctions";
import { SiteLinksSearchBoxJsonLd } from "next-seo";

// Search component displayed when the user is in large view near the group of Link (menuLink.js)

interface SearchBarProps {
  className?: string;
  shallow?: boolean;
  containerClassName?: string;
  defaultValue: string | string[];
  pathName: string;
  placeHolder: string;
  size?: "sm" | "lg";
  slug: boolean;
}

export default function SearchBar({
  className = "",
  shallow,
  defaultValue,
  pathName,
  placeHolder,
  size = null,
  slug,
}: SearchBarProps) {
  const { t } = useTranslation("common");

  const router = useRouter();
  // React-hook-form initialization
  const methods = useForm();
  const { getValues, register, reset } = methods;

  const onSubmitSearchField = (data) => {
    router.push(
      {
        pathname: "/" + pathName + (slug ? "/ALL_PRODUCTS" : ""),
        query: { ...removeEmptyKeys({ ...router.query, Name: data.Name, Page: 1 }) },
      },
      undefined,
      { shallow: shallow == undefined ? true : shallow }
    );
  };

  function _handleKeyDown(e) {
    if (e.key === "Enter") {
      e.target.blur(); // Hide mobile keyboard
      router.push(
        {
          pathname: "/" + pathName + (slug ? "/ALL_PRODUCTS" : ""),
          query: { ...removeEmptyKeys({ ...router.query, Name: e.target.value, Page: 1 }) },
        },
        undefined,
        { shallow: shallow == undefined ? true : shallow }
      );
      e.preventDefault();
    }
  }

  return (
    <div className={className}>
      {/* SEO || FIXME:  search_term_string is also added at the end of potentialActions.target, should remove it. */}
      <SiteLinksSearchBoxJsonLd
        url={process.env.NEXT_PUBLIC_BASE_URL}
        potentialActions={[
          {
            target: `${process.env.NEXT_PUBLIC_BASE_URL}/catalogue/ALL_PRODUCTS?Page=1&Name=`,
            queryInput: "search_term_string",
          }
        ]}
      />
      <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit(onSubmitSearchField)}>
          <InputGroup className={`${s.searchbar}`}>
            <InputGroup.Text className={`${s.searchicon}`} id="inputGroup-sizing-sm">
              <Button variant="link" className="p-0" type="submit" aria-label="searchbar">
                <SearchIcon height="28" width="28" color="black" />
              </Button>
            </InputGroup.Text>

            <Form.Control
              size={size}
              ref={register()}
              name="Name"
              className={`fw-medium shadow-none ${s.searchform}`}
              aria-label="searchbar"
              aria-describedby="searchbar"
              placeholder={placeHolder}
              defaultValue={defaultValue}
              onKeyPress={_handleKeyDown}
            />
            <InputGroup.Text className={`${s.searchicon}`} id="inputGroup-sizing-sm">
              <Button
                variant="link"
                className="p-0"
                onClick={() => {
                  reset({ ...getValues, Name: "" });
                  router.push({
                    pathname: "/" + pathName + (slug ? "/ALL_PRODUCTS" : ""),
                    query: { ...removeEmptyKeys({ ...router.query, Name: "", Page: 1 }) },
                  });
                }}
              >
                <XIcon height="22" width="22" color="black" />
              </Button>
            </InputGroup.Text>
          </InputGroup>
        </Form>
      </FormProvider>
    </div>
  );
}
